import { readBackendError } from 'features/Weather/features/WeatherAlerts/features/AlertCreator/utils/femaSubmissionResult.utils';

/**
 * The editor has no expiration input: the Global Actions service sets `expires` from the update
 * interval (card BE-25). A finding about `expires` (FEMA 406/506/613) is about the interval.
 */
export const GLOBAL_ACTION_FINDING_LABELS = { expires: 'Active event update interval' };

/**
 * Reads a failed Global Action save. A save-time IPAWS refusal answers 400 with the refusal body
 * (`message`, `findings[]` with `field`, `message` and `code`). The reader is the one the Alert
 * Creator uses, so the body is read from `raw` (axiosBaseQuery) or `data`.
 * @param {unknown} error The error from the RTK mutation.
 * @returns {{ message: string, findings: object[] }} The message and the field findings.
 */
export const readGlobalActionSaveError = (error) => {
  const fallback =
    error?.status === 403
      ? 'You do not have permission to save this Global Action.'
      : 'Failed to save global action.';
  const { message, findings } = readBackendError(error, fallback);
  return {
    message: message || error?.data?.error || fallback,
    findings: Array.isArray(findings) ? findings : [],
  };
};
